export const BOX_SHADOW = '0 5px 25px 0 rgba(0, 0, 0, 0.15),0 1px 8px 0 rgba(0, 0, 0, 0.12)';

export const MOBILE_MAX_WIDTH = '(max-width:800px)';
